module.exports = __webpack_public_path__ + "img/nodata.6b888395.png";